import { Heading } from '@ui'
import { APP_NAME } from '../brand.js'

// Public (no sign-in): the app's Settings links here. Keep the data credits in step with what the
// app and site actually use, and with the attribution lines they already show beside the data.
export default function Credits() {
  return (
    <article className="legal">
      <Heading size={3}>Credits</Heading>

      <Heading level={2} size={5} mt={4}>Built with Claude Code</Heading>
      <p>
        {APP_NAME}, the Android app and this website, was designed and written with{' '}
        <a href="https://claude.ai/code" target="_blank" rel="noreferrer">Claude Code</a>,
        Anthropic's coding assistant, working with its developer.
      </p>

      <Heading level={2} size={5} mt={4}>Maps</Heading>
      <ul>
        <li>
          Ordnance Survey maps: contains OS data © Crown copyright and database rights, from the{' '}
          <a href="https://osdatahub.os.uk/" target="_blank" rel="noreferrer">OS Data Hub</a>.
        </li>
        <li>Google Maps (in the app).</li>
        <li>
          Mapbox Outdoors (a map style on the website): © <a href="https://www.mapbox.com/about/maps/" target="_blank" rel="noreferrer">Mapbox</a>{' '}
          © <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">OpenStreetMap contributors</a>.
        </li>
        <li>
          Maps on shared walk pages: © <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">OpenStreetMap contributors</a>,
          tiles from openstreetmap.org.
        </li>
        <li>
          Snap to path uses <a href="https://valhalla.github.io/valhalla/" target="_blank" rel="noreferrer">Valhalla</a>{' '}
          with path data © <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">OpenStreetMap contributors</a>{' '}
          (ODbL).
        </li>
        <li>
          Place names for photos: district boundaries from the{' '}
          <a href="https://geoportal.statistics.gov.uk/" target="_blank" rel="noreferrer">Office for National Statistics</a>,
          licensed under the{' '}
          <a href="https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/" target="_blank" rel="noreferrer">Open Government Licence v3.0</a>{' '}
          (contains OS data © Crown copyright and database right 2025); counties from{' '}
          <a href="https://www.geofabrik.de/" target="_blank" rel="noreferrer">Geofabrik</a>&apos;s outlines,
          © <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">OpenStreetMap contributors</a> (ODbL).
        </li>
      </ul>

      <Heading level={2} size={5} mt={4}>Weather</Heading>
      <ul>
        <li>Includes weather data from Google (Google Maps Platform Weather API).</li>
        <li>
          Contains Met Office data © Crown copyright, from{' '}
          <a href="https://datahub.metoffice.gov.uk/" target="_blank" rel="noreferrer">Met Office DataHub</a>.
        </li>
        <li>Data from <a href="https://api.met.no/" target="_blank" rel="noreferrer">MET Norway</a> (CC BY 4.0).</li>
        <li>
          Weather data by <a href="https://open-meteo.com/" target="_blank" rel="noreferrer">Open-Meteo.com</a>{' '}
          (CC BY 4.0; Met Office models CC BY-SA 4.0).
        </li>
        <li>Weather warnings are credited to the agency that issued each one, where it is shown.</li>
      </ul>

      <Heading level={2} size={5} mt={4}>Software</Heading>
      <p>
        The app uses Kotlin, Jetpack Compose and Room, and the Google Maps SDK for Android. This site
        uses React, React Bootstrap, Leaflet and Firebase Authentication in the browser, and Go with
        Gin, pgx and Goose on the server, with PostgreSQL. Errors are reported to Sentry. Each is used under its own open-source
        licence.
      </p>
    </article>
  )
}
